import {Record, List} from 'immutable';

import BehaviorsCollection from 'web-app/behaviors/behaviors-collection';

import Name from '../common/name';
import Image from '../common/image';
import Address from '../common/address';

const KikuRelation = Record({
    employeeId: '',
    maritalStatus: null,
});

const kikuRelationFromApi = data => new KikuRelation(data);

const Contact = Record({
    relationId: '',
    childId: '',
    employeeId: '',
    behaviors: null,
    name: Name.default,
    extraInfo: '',
    email: '',
    loginId: '',
    famlyId: '',
    image: Image.default,
    roles2: List(),
    invitations: List(),
    priority: 1,
    address: Address.default,
    status: '',
    phone: '',
    workPhone: '',
    homePhone: '',
    placeOfWork: '',
    occupation: '',
    childCustody: false,
    childLivesAt: false,
    hideFromPhoneList: false,
    protectedAddress: false,
    roles: List(),
    ssn: '',
    ssnToken: null,
    ssnLoading: false,
    ssnLoaded: false,
    updating: false,
    deleting: false,
    removingLogin: false,
    addressLoading: false,
    addressLoaded: false,
    kikuRelation: new KikuRelation(),
    associatedBillPayers: List(),
    emergencyContact: false,
    hasWMGAccess: false,
});

const fromAPI = data => {
    return new Contact({
        ...data,
        behaviors: new BehaviorsCollection(data.behaviors ? data.behaviors : []),
        name: Name.fromAPI(data.name),
        roles2: List(data.roles2),
        invitations: data.invitations ? List(data.invitations) : List(),
        image: Image.fromAPI(data.image),
        address: Address.fromAPI(data.address),
    });
};

export default {
    record: Contact,
    default: new Contact(),
    fromAPI,
    kikuRelationFromApi,
};
